module.exports = __webpack_public_path__ + "img/ice-cream-stick-icon.91f57f3e.svg";